import { styled } from '@volkswagen-onehub/components-core';
import { convertBreakpointsToMediaQueries } from '@/modules/utils/themeUtils';

export const StyledFootnote = styled.div(
  ({ theme }) => `
  color:${theme.colors.content.secondary};
  width: 100%;
  padding: ${theme.size.static370} ${theme.size.static400};

  ${convertBreakpointsToMediaQueries({
    b1280: {
      padding: `${theme.size.static530} ${theme.size.static750}`,
    },
  })}
`
);
